// extracted by mini-css-extract-plugin
export default {"container":"HPkOp7","withMobilePadding":"YjQEvU"};